import Vue from 'vue'

import Vuex from 'vuex'

import layout from '@/plugins/store/modules/layout'
import auth from '@/plugins/store/modules/auth'
import core from '@/plugins/store/modules/core'

Vue.use(Vuex)

const state = {}

const mutations = {}

const actions = {}

const getters = {}

const modules = {
  layout,
  auth,
  core: core
}

const options = {
  state,
  mutations,
  actions,
  getters,
  modules
}

const store = new Vuex.Store(options)

export default store
